import React, { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import Select from "../generic/Select";
import LocationPicker from "../generic/LocationPicker";

const distanceOptions = [
  { value: "Upto 10 miles", label: "Upto 10 miles" },
  { value: "Upto 25 miles", label: "Upto 25 miles" },
  { value: "Upto 50 miles", label: "Upto 50 miles" },
  { value: "I'm open to travelling", label: "I'm open to travelling" },
];

const PersonalInfoForm = ({ profile = {}, onChange }) => {

   const getInitialLocation = (loc) => {
    return null;
  };

   const [formData, setFormData] = useState({
    first_name: profile.first_name || "",
    last_name: profile.last_name || "",
    email: profile.email || "",
    phone_number: profile.phone_number || "",
    location: null,
    working_distance: profile.working_distance || "",
  });

  useEffect(() => {
    setFormData({
      first_name: profile.first_name || "",
      last_name: profile.last_name || "",
      email: profile.email || "",
      phone_number: profile.phone_number || "",
      location: null,
      working_distance: profile.working_distance || "",
    });
  }, [profile.first_name, profile.last_name]);

  const handleFieldChange = (field, value) => {
  // 1. Create the updated data object first
  const newData = { ...formData, [field]: value };
  setFormData(newData);

  // 2. Prepare the object for the parent
  // We must ensure the 'location' we pass back is the location from the state,
  // not the 'value' of the field currently being changed.
  const profileUpdate = {
    ...newData,
    // Only stringify if it's an object, otherwise keep the existing string
    location: (typeof newData.location === "object" && newData.location !== null)
              ? JSON.stringify(newData.location)
              : newData.location,
  };

  onChange?.(profileUpdate);
};
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-16">
      <div className="flex flex-col gap-2">
        <Label className="font-bold">First Name</Label>
        <Input
          placeholder="Jane"
          value={formData.first_name}
          onChange={(e) => handleFieldChange("first_name", e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label className="font-bold">Last Name</Label>
        <Input
          placeholder="Doe"
          value={formData.last_name}
          onChange={(e) => handleFieldChange("last_name", e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label className="font-bold">Email Address</Label>
        <Input
          type="email"
          placeholder="contact@company.com"
          value={formData.email}
          onChange={(e) => handleFieldChange("email", e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label className="font-bold">Contact Phone</Label>
        <Input
          placeholder="Enter phone number"
          value={formData.phone_number}
          onChange={(e) => handleFieldChange("phone_number", e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-2 md:col-span-2">
        <Label className="font-bold">Location</Label>
        <LocationPicker
          value={formData.location}
          onChange={(val) => handleFieldChange("location", val)}
          placeholder="Click to select venue location on map"
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label className="font-bold">Working Distance</Label>
        <Select
          options={distanceOptions}
          placeholder="Select working distance"
          value={formData.working_distance}
          onChange={(val) => handleFieldChange("working_distance", val)}
        />
      </div>
    </div>
  );
};

export default PersonalInfoForm;
